<template>
  <div class="index" @click="hidedialog">
    <div class="header-wrap">
      <header>
        <div class="header-left">
          <div
            style="margin-left: 20px"
            @click="linkTo('https://www.joyousoa.com')"
          >
            <img style="width: 150px" src="./../../assets/hr_login_blue.png" />
          </div>
          <div class="helptitle">
            <el-input
              v-model="typeListParams.title"
              placeholder="请输入要搜索的内容"
              @keyup.enter.native="getHelpList"
            >
            </el-input>
          </div>
        </div>
      </header>
    </div>
    <div class="content">
      <div class="content-left">
        <el-menu :default-active="defaultAction" class="el-menu-vertical-demo">
          <el-menu-item
            :index="item.index"
            v-for="item in tabList"
            :key="item.index"
            @click="changeMenu(item)"
          >
            <span slot="title" style="font-size: 16px">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="content-right">
        <div class="index">
          <el-row>
            <el-col :span="22" :offset="1">
              <div ref="be" class="crossRotate">
                <div class="help-header">常见问题列表</div>
                <div
                  style="border-bottom: 1px solid #e7e7e7"
                  v-for="(item, index) in helpList"
                  :key="index"
                >
                  <p
                    class="help-title"
                    @click="handleResize(item.id, item.title)"
                  >
                    {{ item.title }}
                  </p>
                </div>
                <div class="page">
                  <el-pagination
                    v-if="total"
                    small
                    :current-page="typeListParams.pageNumber"
                    :page-size="typeListParams.pageSize"
                    :page-sizes="[5, 10, 20, 30]"
                    @current-change="changePage"
                    layout="total,prev, pager, next"
                    :total="total"
                  ></el-pagination>
                </div>
              </div>
              <div ref="after" class="crossRotate1">
                <div style="padding: 40px 0">
                  <div class="click-btn">
                    <i class="el-icon-back" @click="handleBe"></i>
                  </div>
                  <h3>{{ title }}</h3>
                  <div v-loading="!helpDetail" v-html="helpDetail"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpCenterPage, helpDetailById, openList } from "@/api/setUp.js";

export default {
  name: "index",
  components: {},
  data() {
    return {
      tabList: [
        {
          name: "帮助文档",
          index: "1",
          mask: "HELP_DOCUMENTATION",
        },
        {
          name: "短信中心帮助文档",
          index: "2",
          mask: "SMS_HELPCENTER",
        },
        {
          name: "悦享心语帮助文档",
          index: "3",
          mask: "CARD",
        },
      ],
      menuName: "",
      siteUrl: this.$http.defaults.url_base,
      defaultAction: "1",
      catalog: "",
      activeNames: [],
      helpList: [],
      helpDetail: "",
      title: "",
      total: 0,
      typeListParams: {
        app: "SALARY",
        pageNumber: 1,
        size: 10,
        title: "",
        mask: "HELP_DOCUMENTATION",
      },
    };
  },
  mounted() {
    this.defaultAction = this.$route.query.id || "1";
    // 1 :工资条  2：短信  3 ：贺卡
    this.typeListParams.mask =
      this.$route.query.id == 1
        ? "HELP_DOCUMENTATION"
        : this.$route.query.id == 2
        ? "SMS_HELPCENTER"
        : "CARD";
    this.getHelpList();
  },
  computed: {
    nameChange() {
      return this.$store.state.modifyName;
    },
  },
  watch: {
    nameChange(val) {
      console.log(val);
      if (val) {
        // this.menuName = JSON.parse(Cookie.get('userInfo')).abbreviation
        //
        this.$store.commit("modifyName", false);
      }
    },
  },
  methods: {
    linkTo(url) {
      window.open(url, "_blank");
    },
    changeMenu(item) {
      this.defaultAction = item.index;
      this.typeListParams.pageNumber = 1;
      this.typeListParams.pageNum = 1;
      this.typeListParams.title = "";
      this.typeListParams.mask = item.mask;
      this.getHelpList(item.mask);
    },
    async getHelpList() {
      let _params = Object.assign(this.typeListParams, {
        pageNumber:
          this.typeListParams.pageNumber > 0
            ? this.typeListParams.pageNumber - 1
            : 0,
      });
      let res = await openList(_params);
      this.helpList = res.data;
      this.total = Number(res.headers["x-total-count"]);
    },
    // async getHelpList() {
    //     let res = await helpCenterPage({
    //         pageNumber:this.tableinfo.pageNumber - 1,
    //         size: this.tableinfo.size,
    //         catalogId: this.tableinfo.catalogId,
    //         title: this.tableinfo.title,
    //     });
    //     this.helpList = res.data;
    //     this.total = +res.headers["x-total-count"];
    // },
    changePage(val) {
      this.typeListParams.pageNumber = val;
      this.getHelpList();
    },
    async handleResize(id, title) {
      this.$refs.be.className = "crossRotate1";
      this.$refs.after.className = "crossRotate";
      this.title = title;
      let res = await helpDetailById({ id: id });
      this.helpDetail = res.data.content;
    },
    handleBe() {
      this.helpDetail = "";
      this.$refs.be.className = "crossRotate";
      this.$refs.after.className = "crossRotate1";
    },
    hidedialog(e) {
      if (e.target.className != "tipList") {
        this.$store.state.showTip = false;
      }
    },
    linkto(path) {
      this.$router.push(path);
    },
    onerror() {
      this.$message({
        type: "info",
        message: "上传失败",
      });
    },
    logout() {
      window.sessionStorage.removeItem("token");
      this.$router.replace("/login");
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-bottom: 1px solid rgba(204, 204, 204, 0.3);
  header {
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: relative;
    .header-left {
      display: flex;
      align-items: center;
      justify-content: left;
      .logo {
        width: 40px;
        height: 40px;
        background: #f1b619;
        border-radius: 8px;
        font-size: 30px;
        color: #fff;
        font-weight: 700;
        line-height: 40px;
        text-align: center;
        margin-right: 8px;
      }
      .helptitle {
        width: 500px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 33px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
}

.content {
  display: flex;
  .content-left {
    width: 185px;
    height: calc(100vh - 80px);
    position: relative;
    border-right: solid 1px #e6e6e6;
    /deep/.is-active {
      background: #377cfd;
      color: #fff;
      border-left: 5px solid rgba(255, 255, 255, 0.715);
    }
    img {
      position: absolute;
      bottom: 15px;
      left: 15px;
      width: 85%;
      text-align: center;
    }
  }
  .content-right {
    overflow: auto;
    background: #f7f7f8;
    flex: 1;
    height: 95vh;
    height: calc(100vh - 66px);
    .index {
      padding-top: 20px;
    }
  }
}

.el-icon-questio {
  font-size: 22px;
  // background-color: #444;
  width: 190px;
  height: 50px;
  font-size: 16px;
  color: #377cfd;
  font-weight: 600;
  .phone-box {
    color: #377cfd;
    font-size: 23px;
  }
}
.hover-i {
  float: right;
  color: rgba(131, 143, 153, 1);
  font-size: 16px;
  cursor: pointer;
  position: relative;
  &:hover {
    &:after {
      position: absolute;
      bottom: -30px;
      right: 0px;
      width: 300px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      font-size: 12px;
      color: rgba(44, 45, 58, 1);
      text-align: center;
      background: rgba(243, 245, 247, 1);
      border-radius: 4px;
      content: "如有疑问，请致电客服热线：18971608045";
    }
  }
}

.active {
  color: rebeccapurple;
}
.el-dropdown-link {
  cursor: pointer;
}
.index {
  .dialog-footer {
    padding-bottom: 80px;
  }
  .btn-container {
    text-align: center;
  }
}

.router-link {
  display: inline-block;
  margin-left: 40px;
  > a {
    display: inline-block;
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(131, 143, 153, 1);
    &.active {
      color: #152436;
      border-bottom: 2px solid #377cfd;
    }
  }
}
/deep/.el-button--success {
  /*font-weight: 600;*/
  font-size: 17px;
  font-family: PingFangSC-Semibold;
}
.crossRotate {
  width: 100%;
  transition: all 1s;
  display: inline-block;
}

.crossRotate1 {
  width: 0;
  transition: all 1s;
  display: none;
}

.help-header {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2c2d3a;
  line-height: 28px;
  margin: 10px 0 26px 0;
}

.help-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);

  line-height: 48px;
  padding-left: 20px;
  cursor: pointer;
  box-shadow: 0px 0px 0px 0px rgba(224, 234, 241, 1);

  &:hover {
    background-color: rgba(250, 250, 250, 1);
  }
}

.click-btn {
}

.click-btn i {
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
}

h3 {
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(44, 45, 58, 1);
  margin: 50px 0;
}

.index {
  background: #fff;
  .help-header {
    font-size: 22px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
    // line-height: 30px;
  }

  .hover-i {
    float: right;
    color: rgba(131, 143, 153, 1);
    font-size: 16px;
    cursor: pointer;
    position: relative;

    &:hover {
      &:after {
        position: absolute;
        bottom: -30px;
        right: 0px;
        width: 220px;
        color: rgba(44, 45, 58, 1);
        text-align: center;
        background: rgba(243, 245, 247, 1);
        border-radius: 4px;
        content: "联系客服 18971608045";
      }
    }
  }
}

.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
</style>
